import React from 'react';

import ReceiptLongIcon from '@mui/icons-material/ReceiptLong';
import { Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from '@mui/material';

import { formatSyncedMoney } from '../../Assets/utils';
import RelatedListCard from '../RelatedListCard';
import { RELATED_PREVIEW_LIMIT, accountPath } from '../accountRelatedModel';
import { useAccountOfferId } from '../useAccountOfferId';

import { useAccountExpenses } from './useAccountExpenses';

interface Props {
  accountId: string;
}

export default function AccountExpensesCard({ accountId }: Props) {
  const offerId = useAccountOfferId();
  const { error, expenses, isLoading } = useAccountExpenses(accountId);

  return (
    <RelatedListCard
      count={expenses.length}
      error={error}
      icon={<ReceiptLongIcon color="action" />}
      isLoading={isLoading}
      isSampleData
      title="Expenses"
      viewAllTo={accountPath(accountId, offerId, '/expenses')}
    >
      <TableContainer>
        <Table size="small">
          <TableHead>
            <TableRow>
              <TableCell sx={{ minWidth: 200 }}>Expense Name</TableCell>
              <TableCell>Type</TableCell>
              <TableCell align="right">Total Cost</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {expenses.slice(0, RELATED_PREVIEW_LIMIT).map((expense) => (
              <TableRow key={expense.id} hover>
                <TableCell>{expense.name}</TableCell>
                <TableCell>{expense.type}</TableCell>
                <TableCell align="right">{formatSyncedMoney(expense.currency, expense.totalCost)}</TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </RelatedListCard>
  );
}
